import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentTablePaginator = ({
  page,
  pageCount,
  onPaginate
}) => {
  const handlePaginateClick = event => {
    const nextPage = event.target.value;
    if (page !== nextPage) {
      onPaginate(nextPage);
    }
  };
  return /*#__PURE__*/_jsx(UIPaginator, {
    className: "m-top-4",
    onPageChange: handlePaginateClick,
    page: page,
    pageCount: pageCount,
    showFirstLastButtons: true
  });
};
export default ContentTablePaginator;